import GroupsEditor from "./GroupsEditor";

export default GroupsEditor;
